import { API } from "./axiosInstance"

/**
 * Gets all the messageTypes
 * @returns the messageTypes
 */
export const getMessageTypes = async () => {
    const messageTypes = await API.get(`/messageTypes`);
    return messageTypes.data;
}
